import { ISOCountry } from "cookiesConsent/domain/ISOCountry"
import {
  JurisdictionRules,
  GdprConsentRules,
  CanadaConsentRules,
  UsConsentRules,
  DefaultConsentRules
} from "cookiesConsent/domain/jurisdiction"

const gdprCountries: ReadonlyArray<string> = [
  `AT`,
  `BE`,
  `BG`,
  `HR`,
  `CY`,
  `CZ`,
  `DK`,
  `EE`,
  `FI`,
  `FR`,
  `DE`,
  `GR`,
  `HU`,
  `IE`,
  `IT`,
  `LV`,
  `LT`,
  `LU`,
  `MT`,
  `NL`,
  `PL`,
  `PT`,
  `RO`,
  `SK`,
  `SI`,
  `ES`,
  `SE`,
  `IS`,
  `LI`,
  `NO`,
  `GB`
]

const jurisdictionFromCountry = (country: ISOCountry): JurisdictionRules => {
  if (country.isOneOf(gdprCountries)) {
    return new GdprConsentRules()
  } else if (country.isOneOf([`CA`])) {
    return new CanadaConsentRules()
  } else if (country.isOneOf([`US`])) {
    return new UsConsentRules()
  } else {
    return new DefaultConsentRules()
  }
}

export default jurisdictionFromCountry
